"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarHasModificationWidget = void 0;
var React = require("react");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var InfoQuestionCollapseWrapper_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapper");
var CarHasModificationWidget = /** @class */ (function (_super) {
    __extends(CarHasModificationWidget, _super);
    function CarHasModificationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.showInfoHandler = _this.showInfoHandler.bind(_this);
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        if (_this.props.interaction.vehicles[_this.vehicleIndex].hasModifications === undefined) {
            _this.state = {
                showInfo: false,
                hasModification: false,
                hasNoModification: false
            };
        }
        else {
            _this.state = {
                showInfo: false,
                hasModification: _this.props.interaction.vehicles[_this.vehicleIndex].hasModifications,
                hasNoModification: !_this.props.interaction.vehicles[_this.vehicleIndex].hasModifications
            };
        }
        return _this;
    }
    CarHasModificationWidget.prototype.render = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var label = React.createElement("span", { className: "vehicle-modifications-label" },
            "Does this ",
            vehicle.make,
            ", ",
            vehicle.model,
            vehicle.registrationNumber && " (".concat(vehicle.registrationNumber, ")"),
            " have any modifications, other than for disabilities, air conditioning, fog lights, parking sensors and tow bars?");
        var info = this.renderHtml(" <p className=\"mb-0\">We cover cars with disability modifications, air conditioning, fog lights, parking sensors and tow bars.\n                                <br/>We don't cover other modifications, which include, but aren't restricted to:</p>\n                            <ul>\n                                <li>bodywork, such as spoilers or body kits</li>\n                                <li>suspension or brakes</li>\n                                <li>cosmetics, such as alloy wheels</li>\n                                <li>performance, such as engine and exhaust.</li>\n                            </ul>");
        return (React.createElement(InfoQuestionCollapseWrapper_1.InfoQuestionCollapseWrapper, { label: label, info: info },
            this.renderInputField(),
            this.renderValidationResult()));
    };
    CarHasModificationWidget.prototype.renderInputField = function () {
        return (React.createElement("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Does your car have any modifications, other than for disabilities?" },
            React.createElement("div", { className: "custom-control custom-radio" },
                React.createElement("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "hasModification-true", id: "hasModificationstrue", value: "true", checked: this.state.hasModification, onChange: this.handleOnChangeEvent }),
                React.createElement("label", { className: "custom-control-label", htmlFor: "hasModificationstrue" }, "Yes")),
            React.createElement("div", { className: "custom-control custom-radio" },
                React.createElement("input", { className: "custom-control-input ".concat(this.getInputValidationClass()), type: "radio", name: "hasModification-false", id: "hasModificationsfalse", value: "false", checked: this.state.hasNoModification, onChange: this.handleOnChangeEvent }),
                React.createElement("label", { className: "custom-control-label", htmlFor: "hasModificationsfalse" }, "No"))));
    };
    CarHasModificationWidget.prototype.handleOnChangeEvent = function (event) {
        var carHasModification = event.target.value === "true";
        if (carHasModification) {
            this.props.onStateChange(this.props.question.interactionField, true);
            this.setState({
                hasModification: true,
                hasNoModification: false
            });
        }
        else {
            this.props.onStateChange(this.props.question.interactionField, false);
            this.setState({
                hasModification: false,
                hasNoModification: true
            });
        }
        _super.prototype.validateInternal.call(this, event.target.value);
        this.changelogRecorder.recordQuestion("change", this.props);
    };
    CarHasModificationWidget.prototype.showInfoHandler = function () {
        this.setState({
            showInfo: !this.state.showInfo
        });
    };
    return CarHasModificationWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.CarHasModificationWidget = CarHasModificationWidget;
//# sourceMappingURL=CarHasModificationWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/CarHasModificationWidget.js
// module id = 3322
// module chunks = 0